module.exports = __webpack_public_path__ + "static/media/family-and-relationships.fa17fcbf.png";